// extracted by mini-css-extract-plugin
export default {"snackbar":"Snackbar_snackbar__StvjI","hidden":"Snackbar_hidden__DFh0J","error":"Snackbar_error__L+7Ko","success":"Snackbar_success__wt+9B"};